/**
 * Helpers for Master Tour Calendar send actions (rider advance + contacts share).
 * Does not invent PDFs or venue inboxes — maps package checkboxes onto live share modules.
 */

export const RIDER_PACKAGE_SECTIONS = [
  { key: 'tech', label: 'Technical riders', meta: 'Input lists, backline, power', modules: ['RIDER'] },
  { key: 'hosp', label: 'Hospitality riders', meta: 'Dressing rooms, catering', modules: ['RIDER'] },
  { key: 'prod', label: 'Production riders', meta: 'Stage, lights, audio', modules: ['RIDER'] },
  { key: 'vehicle', label: 'Vehicle information', meta: 'Bus, trailer, parking, load-in', modules: ['RIDER'] },
  { key: 'plots', label: 'Stage plots & input lists', meta: 'PDF attachments', modules: ['STAGE', 'FILES'] },
  { key: 'coi', label: 'Certificate of insurance', meta: 'Current COI', modules: ['FILES'] },
];

export const DEFAULT_RIDER_PACKAGE = {
  tech: true,
  hosp: true,
  prod: true,
  vehicle: false,
  plots: false,
  coi: true,
};

export function shareModulesForRiderPackage(pkg = {}) {
  const mods = [];
  const seen = new Set();
  RIDER_PACKAGE_SECTIONS.forEach((section) => {
    if (!pkg[section.key]) return;
    section.modules.forEach((mod) => {
      if (seen.has(mod)) return;
      seen.add(mod);
      mods.push(mod);
    });
  });
  return mods.length ? mods : ['RIDER'];
}

export function riderPackageMessage(pkg = {}, extra = '') {
  const included = RIDER_PACKAGE_SECTIONS.filter((section) => pkg[section.key]).map((section) => section.label);
  const head = included.length ? `Included in this advance: ${included.join(', ')}.` : '';
  return [head, String(extra || '').trim()].filter(Boolean).join('\n\n');
}

export function combineRiderHtml(daily, full) {
  return [full, daily]
    .map((chunk) => String(chunk || '').trim())
    .filter(Boolean)
    .join('\n');
}

export function resolveWebBaseUrl() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin);
  }
  return 'https://venuereportcard.com';
}
